import Vue from 'vue';

Vue.filter('contactDate', (date, locale = 'en') => {
  const result = new Date(date).toLocaleDateString(locale, {
    month: 'short', day: 'numeric'
  });
  if (result !== 'Invalid Date') return result;
  return '';
});

Vue.filter('messageTime', (date, locale = 'en') => {
  const result = new Date(date).toLocaleTimeString(locale, {
    hour: 'numeric', minute: 'numeric'
  });
  if (result !== 'Invalid Date') return result;
  return '';
});

Vue.filter('messageDate', (date, locale = 'en') => {
  const result = new Date(date).toLocaleDateString(locale, {
    month: 'long', day: 'numeric'
  });
  if (result !== 'Invalid Date') return result;
  return '';
});
